<section id="section-report" class="container-fluid mt-1">
  <div class="row" *ngIf="documentSupportModel">
    <div id="container-report" class="col-12 col-lg-12">
      <table class="page" id="preview-document-support">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{documentSupportModel.documentSupportId}}" class="head col-12 col-lg-12">
                  <!-- Logo -->
                  <img id="logo-{{documentSupportModel.documentSupportId}}" [src]="logoEnterprise" alt=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">

                  <!--Nombre Empresa -->
                  <p id="nombre-empresa-{{documentSupportModel.documentSupportId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{documentSupportModel.enterpriseName}}</p>

                  <!--Nit  -->
                  <label id="t-nit-empresa-{{documentSupportModel.documentSupportId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-nit-empresa' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="nit-empresa-{{documentSupportModel.documentSupportId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{documentSupportModel.enterpriseNit}}
                  </p>

                  <!--Codigo Sucursal -->
                  <label id="t-sucursal-{{documentSupportModel.documentSupportId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-sucursal' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="codigo-sucursal-{{documentSupportModel.documentSupportId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{documentSupportModel.branchCode}}</p>

                  <!--Nombre Sucursal -->
                  <p id="nombre-sucursal-{{documentSupportModel.documentSupportId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{documentSupportModel.branchName}}</p>

                  <!-- Dirección -->
                  <label id="t-direccion-{{documentSupportModel.documentSupportId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-direccion' | formatLabelPipe :
                    elementsLabel}}</label>

                  <p id="direccion-{{documentSupportModel.documentSupportId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{documentSupportModel.addressBranch}}</p>

                  <!--Teléfono  -->
                  <label id="t-telefono-{{documentSupportModel.documentSupportId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-telefono' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="telefono-{{documentSupportModel.documentSupportId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{documentSupportModel.phoneBranch}}</p>

                  <!--titulo-documento-soporte  -->
                  <p id="titulo-documento-soporte-{{documentSupportModel.documentSupportId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">DOCUMENTO SOPORTE EN ADQUISICIONES
                    EFECTUADAS A NO OBLIGADOS A FACTURAR No.</p>

                  <!--consecutivo-documento-soporte  -->
                  <p id="consecutivo-documento-soporte-{{documentSupportModel.documentSupportId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{documentSupportModel.consecutive}}
                  </p>

                  <!-- Fecha Documento Soporte  -->
                  <label id="t-fecha-documento-soporte-{{documentSupportModel.documentSupportId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-fecha-documento-soporte' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-documento-soporte-{{documentSupportModel.documentSupportId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{documentSupportModel.dateDocument | date: 'dd/MM/yyyy hh:mm:ss'}}</p>

                  <!-- Número Resolucion  -->
                  <label id="t-numero-resolucion-{{documentSupportModel.documentSupportId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-numero-resolucion' |
                    formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="numero-resolucion-{{documentSupportModel.documentSupportId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{documentSupportModel.numberResolution}}</p>

                  <!-- Fecha Resolucion  -->
                  <label id="t-fecha-resolucion-{{documentSupportModel.documentSupportId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-fecha-resolucion' |
                    formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="fecha-resolucion-{{documentSupportModel.documentSupportId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{documentSupportModel.dateResolution | date: 'dd/MM/yyyy'}}</p>

                  <!-- Rango Resolucion  -->
                  <label id="t-rango-resolucion-{{documentSupportModel.documentSupportId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-rango-resolucion' |
                    formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="rango-resolucion-{{documentSupportModel.documentSupportId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{documentSupportModel.prefix + ' ' + documentSupportModel.initialDocument + ' al ' +
                    documentSupportModel.prefix + ' ' +
                    documentSupportModel.finalDocument}}</p>

                  <!--Vigencia  -->
                  <label id="t-vigencia-{{documentSupportModel.documentSupportId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-vigencia' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="vigencia-{{documentSupportModel.documentSupportId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{documentSupportModel.validity == null ? 0 :
                    this.documentSupportModel.validity + ' Meses.'}}</p>

                  <!--Proveedor  -->
                  <label id="t-proveedor-{{documentSupportModel.documentSupportId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-proveedor' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="proveedor-{{documentSupportModel.documentSupportId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{documentSupportModel.providerNitName}}
                  </p>

                  <!--Dirección  -->
                  <label id="t-direccion-proveedor-{{documentSupportModel.documentSupportId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-direccion-proveedor' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-proveedor-{{documentSupportModel.documentSupportId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{documentSupportModel.providerAddress}}</p>

                  <!--Teléfono  -->
                  <label id="t-telefono-proveedor-{{documentSupportModel.documentSupportId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-telefono-proveedor' |
                    formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="telefono-proveedor-{{documentSupportModel.documentSupportId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{documentSupportModel.providerPhone}}</p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container">
                <app-custom-table-print id="detalle-documento-soporte-{{documentSupportModel.documentSupportId}}"
                  [columns]="columns" [data]="documentSupportModel.documentSupportDetails" [idMap]="idMap"
                  [documentId]="documentSupportModel.documentSupportId" [footerVisible]="false"
                  [editFormat]="editFormat" (clickTableEvent)="clickTable($event)"
                  (newIndexColumns)="onColumnReorder($event)"></app-custom-table-print>
                <div id="container-totals">
                  <div id="totals">
                    <div class="row d-flex justify-content-end">
                      <label id="foot-t-total-{{documentSupportModel.documentSupportId}}"
                        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                        {{'foot-t-total' | formatLabelPipe : elementsLabel}}</label>
                      <p id="foot-total-{{documentSupportModel.documentSupportId}}" (click)="onClick()"
                        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                        {{documentSupportModel.totalValue | currency}}</p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Observación Documento soporte -->
              <div id="foot-{{documentSupportModel.documentSupportId}}" class="foot container-observations">
                <label id="t-observación-documento-soporte-{{documentSupportModel.documentSupportId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
                  *ngIf="documentSupportModel.observation">{{'t-observación-documento-soporte' |
                  formatLabelPipe : elementsLabel}}</label>
                <p id="observación-documento-soporte-{{documentSupportModel.documentSupportId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
                  *ngIf="documentSupportModel.observation">{{documentSupportModel.observation}}</p>

                <!-- Firma Elaboró-->
                <p id="linea-firma-elaboro-{{documentSupportModel.documentSupportId}}" class="write-line"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
                <label id="t-firma-elaboro-{{documentSupportModel.documentSupportId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'t-firma-elaboro' | formatLabelPipe :
                  elementsLabel}}</label>

                <!-- Firma Aprobó-->
                <p id="linea-firma-aprobo-{{documentSupportModel.documentSupportId}}" class="write-line"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
                <label id="t-linea-aprobo-{{documentSupportModel.documentSupportId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'t-linea-aprobo' | formatLabelPipe :
                  elementsLabel}}</label>

                <!-- QR -->
                <qrcode *ngIf="documentSupportModel.cuds" name="qr" [qrdata]="documentSupportModel.qrData || ''"
                  [allowEmptyString]="true" [cssClass]="'center'" [colorDark]="'#000000ff'" [colorLight]="'#ffffffff'"
                  [elementType]="'canvas'" [errorCorrectionLevel]="'L'" [margin]="4" [scale]="1"
                  [title]="'qr-' + documentSupportModel.documentSupportId" [width]="150"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></qrcode>

                <!-- Fecha Validación Dian  -->
                <label *ngIf="electronicInvoice" id="t-fecha-validacion-{{documentSupportModel.documentSupportId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-fecha-validacion' | formatLabelPipe
                  : elementsLabel}}</label>
                <p *ngIf="electronicInvoice" id="fecha-validacion-{{documentSupportModel.documentSupportId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{documentSupportModel.dateValidationDian | date:'dd/MM/yyyy hh:mm:ss'}}</p>

                <!-- Cuds  -->
                <label *ngIf="electronicInvoice" id="t-cuds-{{documentSupportModel.documentSupportId}}" for=""
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-cuds' | formatLabelPipe :
                  elementsLabel}}</label>
                <p *ngIf="electronicInvoice" id="cuds-{{documentSupportModel.documentSupportId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{documentSupportModel.cuds}}</p>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="1">
              <div class="information-print d-flex">
                <p id="version-cervino" class="fw-bold pe-4">{{ version }}</p>
                <label id="t-fecha-impresion" class="fw-bold pe-2">Fecha:
                </label>
                <p id="fecha-impresion" class="pe-4">
                  {{ dateNow | date : "dd/MM/yyyy" }}
                </p>
                <label id="t-hora-impresion" class="fw-bold pe-2">Hora: </label>
                <p id="hora-impresion" class="pe-4">
                  {{ dateNow | date : "hh:mm:ss a" }}
                </p>
                <label id="t-usuario-impresion" class="fw-bold pe-2">Usuario:
                </label>
                <p id="usuario-impresion" class="pe-4">
                  {{ userAuthenticated }}
                </p>
              </div>
              <div class="d-flex flex-column justify-content-center">
                <div id="copyright" class="d-flex justify-content-center">
                  <p class="mt-2">Documento generada con el Software Cervino de
                    Altos Software SAS. Nit.811.022.121-1. www.altos-soft.com</p>
                  <!-- Proveedor Tecnológico -->
                  <label *ngIf="electronicInvoice" class="ms-1"> - P.T.:</label>
                  <p *ngIf="electronicInvoice">
                    {{documentSupportModel.tecnologyProvider }}</p>
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</section>